import { CheckCircle, Clock, XCircle } from 'lucide-react';

/**
 * Starea unei cereri de inscriere a scolii.
 *
 * Idiomul e cel din `RedemptionStatusBadge` (tichete): `bg-X/N border-X/20 text-X`
 * plus iconita lucide SI text — niciodata culoare singura. Culoarea singura nu ajunge
 * la cine nu distinge rosu de verde, si nici la cine se uita pe un ecran in soare.
 *
 * 🔴 Fundalul e `/5`, nu `/10`, la starea de asteptare: `text-warning` (#B45309)
 * pe `bg-warning/10` cade sub 4,5:1. Masurat pe ecran, nu dedus — aceeasi
 * corectie s-a facut si in jumatatea A.
 *
 * 🔴 Bordura e la culoare PLINA, nu `/20`. Cu `/20` masura 1,4:1 („In Asteptare")
 * si 1,51:1 („Aprobat") fata de fundalul de sub ea — sub pragul de 3:1 din 1.4.11.
 * Conteaza aici mai mult decat in alta parte: fundalul pastilei e `/5`, adica
 * practic alb pe alb, deci bordura era SINGURUL semn ca e o pastila. Nu era o
 * problema de contrast al textului (ala trecea, 4,68 si 4,74) — era una de
 * „componenta nu se citeste ca componenta".
 */
const CONFIG = {
    PENDING: {
        icon: Clock, text: 'În Așteptare',
        clase: 'bg-warning/5 border-warning text-warning',
    },
    APPROVED: {
        icon: CheckCircle, text: 'Aprobat',
        clase: 'bg-success/10 border-success text-success',
    },
    REJECTED: {
        icon: XCircle, text: 'Respins',
        clase: 'bg-error/10 border-error text-error',
    },
} as const;

interface ApprovalStatusBadgeProps {
    status?: 'PENDING' | 'APPROVED' | 'REJECTED';
}

export function ApprovalStatusBadge({ status }: ApprovalStatusBadgeProps) {
    if (!status) return <span>-</span>;

    const c = CONFIG[status];
    const Icon = c.icon;

    return (
        <span
            className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-small font-medium ${c.clase}`}
        >
            <Icon className="size-4 shrink-0" aria-hidden />
            {c.text}
        </span>
    );
}
